import { ActionTree } from 'vuex'
import { SchemeMutation } from './mutations'
import { SchemeState } from './state'
import { RootState } from '../../state'

export enum SchemeAction {
  SetBackgrounded = 'SetBackgrounded',
}

export const actions: ActionTree<SchemeState, RootState> = {
  [SchemeAction.SetBackgrounded](context, data: boolean) {
    context.commit(SchemeMutation.SetBackgrounded, data)
  },
}
